/**
 * Padrões de dado pessoal que nunca podem sair num evento ou log (AGENTS.md, regra 1).
 * Fonte única: o obs-sdk (navegador) e a API (servidor) usam os mesmos padrões.
 */

export const PII_PATTERNS: readonly RegExp[] = [
  /\d{3}\.?\d{3}\.?\d{3}-?\d{2}/, // CPF
  /[^\s@]+@[^\s@]+\.[^\s@]+/, // e-mail
  /\+?\d[\d\s().-]{7,}\d/, // telefone
];

export const REDACTED = "[redacted]";

export function hasPii(value: string): boolean {
  return PII_PATTERNS.some((re) => re.test(value));
}

/** Troca cada trecho com cara de CPF, e-mail ou telefone por "[redacted]". */
export function scrubText(value: string): string {
  return PII_PATTERNS.reduce(
    (text, re) => text.replace(new RegExp(re.source, "g"), REDACTED),
    value,
  );
}
